<template>
  <div class="table">
    <div class="row" :data-letter="getDataLetter()">
      <div class="col col1">
        <div class="img" v-bind:style="imgStyles"></div>
      </div>
      <div class="col col2 cursor-pointer" v-on:click="detail()">
        <div class="title">
          {{ artist.title }}
          <hr />
        </div>
        <div class="action">
          <font-awesome-icon
            v-if="toggleDetail === false"
            :icon="['fas', 'angle-down']"
            class="cursor-pointer"
          />
          <font-awesome-icon
            v-if="toggleDetail === true"
            :icon="['fas', 'angle-up']"
            class="cursor-pointer"
          />
        </div>
      </div>
    </div>
    <div class="caption" v-if="toggleDetail === true">
      <artistDetail :artist="artist" :initLoad="toggleDetail" />
    </div>
  </div>
</template>

<script>
import artistDetail from "./artistDetail.vue";
export default {
  name: "artistList",
  data: function () {
    return {
      flipped: false,
      toggleDetail: false,
      imgStyles: {},
    };
  },
  components: {
    artistDetail,
  },
  props: {
    artist: Object,
  },
  mounted() {
    // do lazy loading of images
    if ("IntersectionObserver" in window) {
      let options = {
        root: document.querySelector("#scrollArea"),
        rootMargin: "150px",
        threshold: 0,
      };
      let observer = new IntersectionObserver(this.listObserver, options);
      observer.observe(this.$el);
    } else {
      // cant do lazy loading images
      this.imgStyles = {
        backgroundImage: `url(${this.artist.photo}?height=810)`,
      };
      this.imgLoaded = true;
    }
  },
  methods: {
    showArtistDetail: async function () {
      if (!this.artist.detail) {
        await this.artist.getDetail();
      }
    },
    detail() {
      this.toggleDetail = !this.toggleDetail;
    },
    listObserver(entries) {
      // lazy load the image
      if (entries[0].isIntersecting && !this.imgLoaded) {
        this.imgStyles = {
          backgroundImage: `url(${this.artist.photo}?height=810)`,
        };
        this.imgLoaded = true;
      }
    },
    getDataLetter() {
      const firstLetter = this.artist.title.slice(0, 1).toUpperCase();
      return /^[a-zA-Z()]$/.test(firstLetter) ? firstLetter : "#";
    },
  },
};
</script>
